import Chart from "react-apexcharts";

export default function DonutChart({ labels, series, colors, height = 320 }) {
  const options = {
    chart: { type: "donut", fontFamily: "Inter, sans-serif" },
    labels,
    colors,
    legend: {
      position: "bottom",
      fontSize: "12px",
      labels: { colors: "#334155" },
      markers: { radius: 4 },
    },
    dataLabels: {
      style: { fontSize: "12px", fontWeight: 600 },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total",
              formatter: () => series.reduce((a, b) => a + b, 0).toLocaleString("es-CL"),
              color: "#0f172a",
              fontSize: "14px",
              fontWeight: 600,
            },
            value: {
              color: "#0f172a",
              fontSize: "22px",
              fontWeight: 700,
              formatter: (v) => Number(v).toLocaleString("es-CL"),
            },
          },
        },
      },
    },
    stroke: { width: 2, colors: ["#fff"] },
  };

  return <Chart options={options} series={series} type="donut" height={height} />;
}
